import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let mainrouter = new Router({
    routes: [{
        path: '/',
        name: 'home',
        component: () => import('./views/Home.vue')
    },
        {
            path: '/products',
            name: 'products',
            component: () => import('./views/Products.vue'),
        },
        {
            path: '/productDetails/:id',
            name: 'productDetails',
            component: () => import('./views/ProductDetails.vue'),
        },
        {
            path: '/caseDetails/:id',
            name: 'caseDetails',
            component: () => import('./views/CaseDetails.vue'),
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/Contact.vue')
        }
    ]
})

// 判断是否需要登录权限 以及是否登录
mainrouter.beforeEach((to, from, next) => {
    // 判断是否需要登录权限
    if (to.matched.some(res => res.meta.requireAuth)) {
        // 判断是否登录
        if (sessionStorage.getItem('token')) {
            next()
        } else {
            // 没登录则跳转到登录界面
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next()
    }
})

export default mainrouter
